<template>
	<div class="role">
		<div class="right-wrap">
			<el-row :gutter="20" v-show="downFile">
				<el-col :span="18">
					<div class="query-wrap">
						<div class="query-date">
							<div class="query-date-label">预约时间</div>
							<el-date-picker v-model="dateValue" type="daterange" value-format="timestamp"
								range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"
								@change="searchDateChange">
							</el-date-picker>
						</div>
						<el-button class="query-btn" @click="getReport">查询</el-button>
						<el-button class="query-btn" @click="handleRet">重置</el-button>
					</div>
				</el-col>
				<el-col :span="6" class="flex-end">
					<button type="submit" class="nextBtn" @click="downExcel">批量导出</button>
					<form :action="http" method="post" autocomplete="off" v-show="false">

						<input type="text" name="ids" :value="selectList" />
						<button type="submit" ref="down">导 出</button>
					</form>
				</el-col>
			</el-row>

			<el-table :data="tableData" @selection-change="handleSelectionChange" class="list">

				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-appoint.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="id" label="编号" class-name="id" min-width="60"></el-table-column>
				<el-table-column prop="mobile" label="手机号" class-name="mobile" min-width="160">
					<template slot-scope="scope">
						{{ scope.row.mobile?scope.row.mobile:'--' }}
					</template>
				</el-table-column>
				<el-table-column prop="idcard" label="身份证号" class-name="idcard" min-width="180">
					<template slot-scope="scope">
						{{ scope.row.idcard?scope.row.idcard:'--' }}
					</template>
				</el-table-column>
				<el-table-column prop="goods_name" label="套餐内容" class-name="package" min-width="160">

				</el-table-column>

				<el-table-column prop="is_finish" label="状态" class-name="is_finish" min-width="80">
					<template slot-scope="scope">
						<span class="order_status_80" v-if="scope.row.is_finish == 80 ">已完成</span>
						<span class="order_status_1" v-if="scope.row.is_finish == 1 ">未完成</span>
						<span class="order_status_0" v-if="scope.row.is_finish == 0 ">--</span>
					</template>
				</el-table-column>
				<el-table-column prop="created_at" label="预约日期" class-name="created_at" min-width="180">
				</el-table-column>
			</el-table>

			<!-- 分页 -->


				<el-pagination v-if="pageCount > 10" class="pagination qjc-texta-c" :current-page.sync="pageNum"
					hide-on-single-page @current-change="handleCurrentChange" prev-text="上一页" next-text="下一页"
					layout="total, prev, pager, next,jumper" :page-size="10" :total="pageCount"></el-pagination>


		</div>
		<Alertb :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
			@on-confirm="confirmDialog" />

	</div>
</template>

<script>
	import appoint from '@/assets/js/appoint';
	import Alertb from '@/components/alertb';

	export default {
		components: {
			Alertb
		},
		name: 'appoint',
		...appoint
	}
</script>

<style scoped>
	.right-wrap>>>.el-table th {
		background-color: #F2F4FA;
	}

	.right-wrap>>>.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 380px;
	}

	.right-wrap>>>.el-date-editor .el-range-separator {
		color: #DBDDE6;
	}
</style>
<style lang="scss" scoped>
	.role {
		display: flex;
		// padding: 24px;
		width: 100%;
		height: 100%;
		// border: 12px solid #F2F4FA;

		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 0 24px 30px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;

			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;

				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;

					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}

				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}

			.left-list {
				padding-top: 20px;
			}

			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}

			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #7A8599;
				background-color: #E8E9EC;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}

			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #E9EDFF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}

		.right-wrap {
			flex: 1;
			width: 100%;
			padding: 28px 24px;

			.query-wrap {
				display: flex;
				align-items: center;
				// justify-content: space-between;
				margin-bottom: 16px;
				padding-right: 1%;

				.query-package {
					width: 226px;
				}
			}

			.c-danger {
				color: #FF4C52;
			}

			.query-date {
				display: flex;
				align-items: center;
				// margin-right: 40px;

				.query-date-label {
					margin-right: 10px;
				}
			}

			.query-btn {
				width: 72px;
				height: 36px;
				line-height: 36px;
				font-size: 15px;
				padding: 0;
				margin-left: 16px;
				border: none;
				color: #fff;
			}

			.el-button:active {
				background-color: #5B73DC;
			}

		}

		.pagination {
			width: 100%;
			text-align: center;
		}

		.foot-pagination {
			// position: fixed;
			// bottom: 0;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			min-width: 1160px;
			max-width: 100%;
			width: 100%;
			height: 80px;
			background-color: #fff;
			z-index: 9;
		}

		.nextBtn {
			
			cursor: pointer;
			width: 96px;
			height: 34px;
			line-height: 34px;
			background: #6883FB;
			border-radius: 17px;
			border: none;
			color: white;
			outline: none;
			font-size: 14px;
		}

		.empty-wrap {
			padding: 100px 0;
		}

		.empty-img {
			width: 280px;
			height: 222px;
		}

	}

	.order_status_80 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #5eb95e;
	}

	.order_status_1 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #F37B1D;
	}
</style>
<style src="@/assets/iconFonts/iconfont.css" scoped></style>
<style src="@/assets/css/bookingInfo.css" scoped></style>